import React from "react";
import Alert from "@amzn/meridian/alert";
import { IApiIndicatorProps } from "./definitions";
import { getErrorMessage } from "./utils";
import Loader from "@amzn/meridian/loader";
import { useNotifications } from "../notifications/hooks";
import Column from "@amzn/meridian/column";

const ApiIndicator: React.FC<IApiIndicatorProps> = (props: IApiIndicatorProps) => {
    const { addToast } = useNotifications();
    const title = "Sorry, something went wrong, please try again later!";
    const message = getErrorMessage(props.error);

    React.useEffect(() => {
        if (props.isError) {
            props.isToastError &&
                addToast({
                    type: "error",
                    title: title,
                    children: message,
                    ...props,
                });
            console.error("API Error message: ", message);
        }
    }, [props.isError, message]);

    return (
        <Column spacing={"100"} minHeight={"15px"}>
            {props.isUninitialized && (
                <Alert size="small" type="neutral" children={"Uninitialized!"} />
            )}
            {props?.isLoading && <Loader size={props.loaderSize} type={props.loaderType} />}
            {!props.isLoading && props.isFetching && (
                <Loader size={props.loaderSize} type={props.loaderType} />
            )}
            {props.isError && !props.isToastError && (
                <Alert type="error" size="small" children={title} />
            )}
        </Column>
    );
};

export default ApiIndicator;
